﻿module.exports = {
    "id": "th",
    "label": "ไทย",
    "rtl": true,

    "translations": {
        "INVALID_LINK_TITLE": "ลิงค์ไม่ถูกต้อง",
        "INVALID_LINK_TEXT":            "กรุณาเลือกปุ่ม \"ยกเลิกการเป็นสมาชิก\" ในลิงค์ที่ปรากฏในอีเมลล์ของคุณ เพื่อยกเลิกการรับอีเมลล์แบบสอบถามจากเรา",
        "UNSUBSCRIBE_ARE_YOU_SURE": "คุณแน่ใจหรือไม่ว่าจะยกเลิกการเป็นสมาชิก (ไม่ต้องการรับอีเมลล์อีก)",
        "UNSUBSCRIBE_CLICK_CONFIRM":    "กรุณาเลือกปุ่ม \"ยกเลิกการเป็นสมาชิก\" เพื่อการยืนยัน",
        "YOU_HAVE_BEEN_UNSUBSCRIBED": "คุณได้ยกเลิกการสมาชิกจากรายชื่ออีเมลล์ของเราแล้ว",
        "UNSUBSCRIBED_IN_ERROR":        "If you have unsubscribed in error, please click the <a href='/resubscribe' class='resubscribe'>resubscribe</a> link.",
        "CANCELLED_STILL_SUBSCRIBED": "<b> ยกเลิก </b> คุณยังคง <b> เป็นสมาชิก </b> รายการอีเมลล์ของเรา",
        "THANK_YOU_FOR_CONTINUING": "ขอบคุณที่ต้องการที่จะร่วมแสดงความคิดเห็นกับเรา",
        "EMAIL_ALREADY_UNSUBSCRIBED": "อีเมลล์นี้ได้  <b>ยกเลิกการเป็นสมากชิก</b>เรียบร้อยแล้ว",
        "CLICK_RESUBSCRIBE_TO_REJOIN": "กรุณากดปุ่ม \"การกลับเป็นสมาชิก\" ด้านล่างเพื่อกลับมาร่วมเป็นสมาชิกกับเราใหม่",
        "YOU_HAVE_BEEN_RESUBSCRIBED": "คุณได้ <b>กลับมาเป็นสมาชิก</b>  ของเราแล้ว",
        "YOU_ARE_ALREADY_SUBSCRIBED": "คุณได้ <b>สมัครสมาชิก </b> กับเราแล้ว",
        "THANK_YOU_FOR_PARTICIPATING": "ขอบคุณที่ร่วมแสดงความคิดเห็นในแบบสอบถามนี้",
        "CHECKING": "กำลังตรวจสอบ….",
        "UNSUBSCRIBE": "ยกเลิกการเป็นสมาชิก",
        "RESUBSCRIBE": "กลับเป็นสมาชิก",
        "EMAIL": "อีเมลล์",
        "CANCEL": "ยกเลิก"
    }
};

